import { Component, input, output } from '@angular/core';
import { switchMap } from 'rxjs';
import { ModalService } from 'src/app/project/components/modal/modal.service';
import { RecurringRemindersService } from 'src/app/project/modules/reminders/recurring-reminders.service';
import { RemindersService } from 'src/app/project/modules/reminders/reminders.service';
import { EEditReminderOptions } from '../point-reminder-modal-edit-reminder-button/point-reminder-modal-edit-reminder-button-consts';

@Component({
    selector: 'pp-reminder-delete-options',
    templateUrl: './reminder-delete-options.component.html',
    styleUrl: './reminder-delete-options.component.scss',
    standalone: false
})
export class ReminderDeleteOptionsComponent {
  ppReminderDeleteOption = input<string>();
  ppReminderDeleteOptionChange = output<string>();
  ppCancel = output<void>();
  ppReminderId = input<string>();
  ppSeriesId = input<string>();
  ppCreatedForMe = input<boolean>();

  EEditReminderOptions = EEditReminderOptions;

  constructor(
    private remindersService: RemindersService,
    private modalService: ModalService,
    private recurringRemindersService: RecurringRemindersService,
  ) {}

  selectOption(option: EEditReminderOptions): void {
    if (this.ppCreatedForMe() && option !== EEditReminderOptions.SERIES) {
      return;
    }

    this.ppReminderDeleteOptionChange.emit(option);
  }

  cancel(): void {
    this.ppCancel.emit();
  }

  delete(): void {
    switch (this.ppReminderDeleteOption()) {
      case EEditReminderOptions.SINGLE:
        this.remindersService.deleteReminder(this.ppReminderId()).subscribe(() => this.close());
        break;
      case EEditReminderOptions.SERIES:
        this.recurringRemindersService.deleteRecurringReminder(this.ppSeriesId()).subscribe(() => {
          this.remindersService.removeRemindersFromSeries(this.ppSeriesId());
          this.close();
        });
        break;
      case EEditReminderOptions.THIS_AND_FUTURE:
        this.recurringRemindersService
          .deleteRecurringReminder(this.ppSeriesId(), this.ppReminderId())
          .pipe(switchMap(() => this.remindersService.fetchRemindersForSeries(this.ppSeriesId())))
          .subscribe(() => this.close());
        break;
    }
  }

  private close(): void {
    this.modalService.hideModal();
  }
}
